import React from 'react';
import Form from 'react-bootstrap/Form'
import FormDelimiter from "../FormDelimiter";
import {PickupPointAddressNPI} from "./PickupPointAddressNPI";
import {ConsigneeAddress} from "../ConsigneeAddress";
import {AddressTMM} from "./AddressTMM";
import Storage from "../../Storage";

export class DeliverTo {
    static door = 'door';
    static pickupPoint = 'pickup_point';
}

function RadioButtons(props) {
    const {
        handleChange,
        values,
    } = props;
    const doorRadio = (
        <Form.Check
            checked={values._deliverTo === DeliverTo.door}
            inline
            type="radio"
            name="_deliverTo"
            label="Deliver to door"
            value={DeliverTo.door}
            id={DeliverTo.door}
            onChange={handleChange}
        />

    );
    const pickupPointRadio = (
        <Form.Check
            checked={values._deliverTo === DeliverTo.pickupPoint}
            inline
            type="radio"
            name="_deliverTo"
            label="Deliver to pickup point"
            value={DeliverTo.pickupPoint}
            id={DeliverTo.pickupPoint}
            onChange={handleChange}
        />

    );
    if (values.lastMileService.code === 'NPI' || values.lastMileService.code === 'NPG') {
        return (
            <div>
                {doorRadio}
                {pickupPointRadio}
            </div>
        )
    } else if (values._deliverTo === DeliverTo.pickupPoint) {
        return (
            <div>
                {pickupPointRadio}
            </div>
        )
    } else {
        return (
            <div>
                {doorRadio}
            </div>
        )
    }
}

export class Address extends React.Component {
    render() {
        const {values} = this.props;
        const {_deliverTo} = values;

        let address;
        if (
            _deliverTo === DeliverTo.door &&
            (values.lastMileService.code === 'NPI' || values.lastMileService.code === 'NPG' || values.lastMileService.code === 'BXB')
        ) {
            address = <ConsigneeAddress {...this.props}/>;
        } else if (
            values.lastMileService.code === 'TMM'
        ) {
            address = <AddressTMM {...this.props}/>;
        } else if (_deliverTo === DeliverTo.pickupPoint && (values.lastMileService.code === 'NPI' || values.lastMileService.code === 'NPG')) {
            address = <PickupPointAddressNPI {...this.props}/>;
        } else {
            address = null;
        }

        if (Storage.isHumAid()) {
            return (
                <div>
                    <FormDelimiter text="ADDRESS"/>
                    <PickupPointAddressNPI {...this.props}/>
                </div>
            )
        }

        return (
            <div>
                <FormDelimiter text="ADDRESS"/>
                <RadioButtons {...this.props}/>
                {address}
            </div>
        )
    }
}
